// Product catalog for mattressDIRECT.in - imported from client's product sheet
// Images are stored locally as WebP in /public/images/products/

export const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_low-cost-mattress/artifacts/w5cydw7f_mattress-direct-logo.webp";

export const IMAGES = {
  heroBedroom: "https://images.unsplash.com/photo-1633948393301-d43e3ec0e5cd",
  warehouse: "https://images.unsplash.com/photo-1583737077382-3f51318d6074",
  stacked: "https://images.unsplash.com/photo-1644335498098-2eebf5d41c5e",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Industries", path: "/industries" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const HERO = {
  eyebrow: "SUPPLYING COMFORT AT SCALE",
  titleLine1: "Bulk Mattresses",
  titleLine2: "for Every Business",
  description:
    "Reliable supply. Consistent quality. Transparent pricing. Browse our industry-wise catalog, check live size-based prices and raise an enquiry in minutes.",
  badgeList: ["HOTELS", "HOSPITALS", "HOSTELS", "APARTMENTS", "& MORE"],
  highlights: [
    { icon: "Layers", title: "Wide Range", sub: "of Mattress Types" },
    { icon: "Ruler", title: "Custom Sizes", sub: "& Specifications" },
    { icon: "Truck", title: "On-Time Delivery", sub: "Pan India" },
    { icon: "ShieldCheck", title: "Trusted by", sub: "Businesses" },
  ],
};

export const INDUSTRIES = [
  {
    slug: "hotels-resorts",
    title: "Hotels & Resorts",
    image: "https://images.unsplash.com/photo-1611892440504-42a792e24d32",
    desc: "Premium comfort for guest rooms and suites at scale.",
    tagline: "From value foam workhorses to luxury pocket springs - mattresses engineered for guest comfort and heavy room turnover.",
  },
  {
    slug: "hospitals-healthcare",
    title: "Hospitals & Healthcare",
    image: "https://images.unsplash.com/photo-1512678080530-7760d81faba6",
    desc: "Hygienic, durable mattresses for patient care.",
    tagline: "Waterproof rexine, fowler-cot and ICU-grade options designed for patient beds and critical care facilities.",
  },
  {
    slug: "educational-institutions",
    title: "Educational Institutions",
    image: "https://images.unsplash.com/photo-1767884162402-683fdd430046",
    desc: "Sturdy hostel and dormitory bedding solutions.",
    tagline: "Tough, easy-maintain mattresses including roll-up and tri-fold options for hostels, dormitories and PG accommodations.",
  },
  {
    slug: "corporate-staff",
    title: "Corporate & Staff Accommodation",
    image: "https://images.unsplash.com/photo-1618773928121-c32242e63f39",
    desc: "Comfortable rest for employees and staff housing.",
    tagline: "Cost-optimized comfort for staff quarters, worker hostels and labour camps - built for daily use.",
  },
];

// Cross-section layer presets (fallback when a product has no cross-section image)
export const LAYER_SETS = {
  foam: [
    { label: "Quilted Knitted Cover", pct: 14, bg: "#dbe4ec", text: "#1c2e3a" },
    { label: "HR Comfort Foam", pct: 38, bg: "#f4a074", text: "#5a2a10" },
    { label: "High-Density Foam Core", pct: 48, bg: "#1c2e3a", text: "#ffffff" },
  ],
  latex: [
    { label: "Organic Cotton Cover", pct: 14, bg: "#e9e2d2", text: "#1c2e3a" },
    { label: "Natural Latex Layer", pct: 46, bg: "#eab308", text: "#3a2c05" },
    { label: "Support Foam Base", pct: 40, bg: "#1c2e3a", text: "#ffffff" },
  ],
};

export const CATALOG = [
  // ---- HOTELS & RESORTS ----
  {
    id: "bonded-foam-mattress-hotels",
    name: "Bonded Foam Mattress",
    displayName: "Bonded Foam Mattress \u2013 Hotels",
    type: "Bonded Foam",
    desc: "High-density rebonded foam provides extra-firm support that retains its shape under heavy daily use. A long-lasting, budget-friendly choice for hotel rooms and guest houses.",
    image: "/images/products/bonded-foam-mattress.webp",
    crossImage: "/images/products/bonded-foam-mattress-cross.webp",
    featured: false,
    startPrice: 5000,
    industries: ["hotels-resorts"],
  },
  {
    id: "bonnell-spring-mattress-hotels",
    name: "Bonnell Spring Mattress",
    displayName: "Bonnell Spring Mattress",
    type: "Bonnell Spring",
    desc: "Interconnected spring coils deliver consistent full-body support and durability. Great for high-traffic hotels and bulk commercial orders.",
    image: "/images/products/bonnell-spring.webp",
    crossImage: "/images/products/bonnell-spring-cross.webp",
    featured: true,
    startPrice: 4000,
    industries: ["hotels-resorts"],
  },
  {
    id: "high-density-foam-mattress-hotels",
    name: "High Density Foam Mattress",
    displayName: "High Density Foam Mattress",
    type: "High-Density Foam",
    desc: "Resilient, firm foam built for frequent commercial use. Maintains structure over time while ensuring reliable guest comfort.",
    image: "/images/products/foam-mattress.webp",
    crossImage: "/images/products/foam-mattress-cross.webp",
    featured: false,
    startPrice: 4000,
    industries: ["hotels-resorts"],
  },
  {
    id: "pocketed-spring-mattress-hotels",
    name: "Pocketed Spring Mattress",
    displayName: "Pocketed Spring Mattress",
    type: "Pocketed Spring",
    desc: "Individually wrapped coils contour to the body and isolate movement, so one guest's shifts won't disturb the other. Ideal for elevated hospitality comfort.",
    image: "/images/products/pocketed-spring-mattress.webp",
    crossImage: "/images/products/pocketed-spring-mattress-cross.webp",
    featured: true,
    startPrice: 6000,
    industries: ["hotels-resorts"],
  },
  {
    id: "luxury-pocketed-spring-mattress-hotels",
    name: "Luxury Pocketed Spring Mattress",
    displayName: "Luxury Pocketed Spring Mattress",
    type: "Luxury Pocket Spring",
    desc: "A premium pocket-coil system designed for high-end hotel stays. Offers targeted pressure relief, motion separation, and an ultra-plush feel.",
    image: "/images/products/luxury-pocketed-spring.webp",
    crossImage: "/images/products/luxury-pocketed-spring-cross.webp",
    featured: false,
    startPrice: 8500,
    industries: ["hotels-resorts"],
  },
  {
    id: "mattress-toppers-hotels",
    name: "Mattress Toppers",
    displayName: "Mattress Toppers",
    type: "Topper",
    desc: "An easy, cost-effective upgrade to extend mattress life and add an extra layer of softness without replacing the entire bed.",
    image: "/images/products/mattress-topper.webp",
    crossImage: null,
    layers: LAYER_SETS.foam,
    featured: false,
    startPrice: 3000,
    industries: ["hotels-resorts"],
  },
  // ---- HOSPITALS & HEALTHCARE ----
  {
    id: "basic-mattress-hospitals",
    name: "Basic Mattress",
    displayName: "Basic Mattress",
    type: "Rexine Medical",
    desc: "Durable, wipe-clean rexine cover designed for everyday clinical hygiene. Practical and easy to sanitize between patients.",
    image: "/images/products/basic-mattress.webp",
    crossImage: "/images/products/32-d-rexine-mattress.webp",
    featured: true,
    startPrice: 3500,
    industries: ["hospitals-healthcare"],
  },
  {
    id: "fowler-cot-mattress-hospitals",
    name: "Fowler Cot Mattress",
    displayName: "Fowler Cot Mattress",
    type: "Fowler Cot",
    desc: "Flexible construction engineered specifically to bend smoothly with multi-section adjustable Fowler hospital beds.",
    image: "/images/products/fowler-cot-mattress.webp",
    crossImage: "/images/products/32-d-rexine-mattress.webp",
    featured: false,
    startPrice: 4000,
    industries: ["hospitals-healthcare"],
  },
  {
    id: "icu-bed-mattress-hospitals",
    name: "ICU Bed Mattress",
    displayName: "ICU Bed Mattress",
    type: "ICU Medical",
    desc: "Pressure-relieving support crafted for long-term bed rest in critical care units. Easy to maintain and built for continuous medical use.",
    image: "/images/products/medical-mattress.webp",
    crossImage: "/images/products/32-d-rexine-mattress.webp",
    featured: true,
    startPrice: 4500,
    industries: ["hospitals-healthcare"],
  },
  // ---- EDUCATIONAL INSTITUTIONS ----
  {
    id: "foam-mattress-educational",
    name: "Foam Mattress",
    displayName: "Foam Mattress \u2013 Education",
    type: "Foam",
    desc: "Simple, reliable support tailored for student dorms and boarding facilities. Lightweight, durable, and low maintenance.",
    image: "/images/products/basic-foam-mattress.webp",
    crossImage: "/images/products/basic-foam-mattress-cross.webp",
    featured: true,
    startPrice: 2500,
    industries: ["educational-institutions"],
  },
  {
    id: "rolling-mattress-educational",
    name: "Rolling Mattress",
    displayName: "Rolling Mattress",
    type: "Roll-Up",
    desc: "Flexible foam roll-up design that makes storage, transport, and quick room layout changes effortless.",
    image: "/images/products/rolling-mattress-1.webp",
    crossImage: "/images/products/rolling-mattress-2.webp",
    featured: false,
    startPrice: 2000,
    industries: ["educational-institutions"],
  },
  {
    id: "folding-mattress-educational",
    name: "Folding Mattress",
    displayName: "Folding Mattress",
    type: "Tri-Fold",
    desc: "Tri-fold design saves floor space during the day and sets up in seconds for nightly sleep. Perfect for shared dorms.",
    image: "/images/products/folding-mattress-1.webp",
    crossImage: "/images/products/folding-mattress-2.webp",
    featured: false,
    startPrice: 2000,
    industries: ["educational-institutions"],
  },
  {
    id: "epe-foam-mattress-educational",
    name: "EPE Foam Mattress",
    displayName: "EPE Foam Mattress \u2013 Education",
    type: "EPE Foam",
    desc: "Ultra-lightweight EPE foam core offers firm, budget-friendly support that is easy for students or staff to handle.",
    image: "/images/products/epe-mattress.webp",
    crossImage: "/images/products/epe-mattress-cross.webp",
    featured: true,
    startPrice: 2000,
    industries: ["educational-institutions"],
  },
  // ---- CORPORATE & STAFF ACCOMMODATION ----
  {
    id: "coir-mattress-corporate",
    name: "Coir Mattress",
    displayName: "Coir Mattress",
    type: "Natural Coir",
    desc: "Natural coir core offers traditional firm support and ventilation. Built to handle continuous use in worker dorms and staff quarters.",
    image: "/images/products/coir-mattress.webp",
    crossImage: "/images/products/coir-mattress-cross.webp",
    featured: false,
    startPrice: 2500,
    industries: ["corporate-staff"],
  },
  {
    id: "foam-mattress-corporate",
    name: "Foam Mattress",
    displayName: "Foam Mattress \u2013 Corporate",
    type: "Foam",
    desc: "Balanced comfort and long-term durability designed for staff housing and company guest rooms.",
    image: "/images/products/foam-mattress-27v09hmc.webp",
    crossImage: "/images/products/foam-mattress-cross-3yv6yrwd.webp",
    featured: true,
    startPrice: 2000,
    industries: ["corporate-staff"],
  },
  {
    id: "epe-foam-mattress-corporate",
    name: "EPE Foam Mattress",
    displayName: "EPE Foam Mattress \u2013 Corporate",
    type: "EPE Foam",
    desc: "Lightweight, moisture-resistant EPE foam provides firm, budget-friendly support. Easy to clean and move around, making it a practical choice for high-volume workforce housing and staff dorms.",
    image: "/images/products/epe-mattress-qy64wpdw.webp",
    crossImage: "/images/products/epe-mattress-cross-d85cm8f.webp",
    featured: false,
    startPrice: 1800,
    industries: ["corporate-staff"],
  },
  {
    id: "bonded-foam-mattress-corporate",
    name: "Bonded Foam Mattress",
    displayName: "Bonded Foam Mattress \u2013 Corporate",
    type: "Bonded Foam",
    desc: "Heavy-duty rebonded foam engineered to withstand long-term use in high-occupancy corporate dorms.",
    image: "/images/products/bonded-foam-mattres.webp",
    crossImage: "/images/products/bonded-foam-mattres-cross.webp",
    featured: false,
    startPrice: 3000,
    industries: ["corporate-staff"],
  },
  {
    id: "natural-latex-mattress-corporate",
    name: "Natural Latex Mattress",
    displayName: "Natural Latex Mattress",
    type: "Natural Latex",
    desc: "Breathable, naturally resilient latex offers ergonomic contouring and long-term durability. A premium, eco-friendly choice for executive staff quarters and corporate guest suites.",
    image: "/images/products/latex-mattress-cross.webp",
    crossImage: null,
    layers: LAYER_SETS.latex,
    featured: true,
    startPrice: 8500,
    industries: ["corporate-staff"],
  },
];

export const productsForIndustry = (slug) => CATALOG.filter((p) => p.industries.includes(slug));

export const PARTNER_POINTS = [
  { icon: "BadgeCheck", label: "Quality Assurance" },
  { icon: "Tag", label: "Competitive Pricing" },
  { icon: "Factory", label: "Large Production Capacity" },
  { icon: "Headset", label: "Dedicated B2B Support" },
];

export const STATS = [
  { value: "150+", label: "Models & Variants" },
  { value: "10,000+", label: "Mattresses Supplied" },
  { value: "500+", label: "Happy Business Clients" },
  { value: "12+", label: "Years of Experience" },
];

export const PRODUCT_RANGE = {
  eyebrow: "OUR PRODUCT RANGE",
  title: "Bulk Mattresses for Every Requirement",
  desc: "Choose from a wide range of mattress types, sizes and comfort levels. We also offer custom manufacturing as per your specifications.",
  items: [
    "Foam Mattresses",
    "Spring Mattresses",
    "Orthopaedic Mattresses",
    "Natural Latex Mattresses",
    "Custom Sizes & Thickness",
  ],
};
